(() => {
  const dialog = document.getElementById('TrustpilotReviews');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const container = dialog.querySelector('[data-reviews-container]');
  const status = dialog.querySelector('[data-reviews-status]');
  const retry = dialog.querySelector('[data-reviews-retry]');
  let timer;
  let opener;
  let initialized = false;
  function preferencesAllowed() {
    if (window.Cookiebot?.consent) return window.Cookiebot.consent.preferences === true;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.preferencesProcessingAllowed === 'function') return privacy.preferencesProcessingAllowed();
    const cookie = document.cookie.match(/(?:^|;\s*)wt_consent=([^;]*)/);
    try {
      const choice = cookie ? JSON.parse(decodeURIComponent(cookie[1])) : null;
      return choice?.preferences === true || choice?.preferences === 1;
    } catch (_) { return false; }
  }
  function loadReviews() {
    clearInterval(timer);
    status.hidden = false;
    retry.hidden = true;
    let attempts = 0;
    const tryLoad = () => {
      if (!dialog.open) return clearInterval(timer);
      if (!preferencesAllowed()) {
        status.hidden = true;
        retry.hidden = false;
        clearInterval(timer);
        return;
      }
      // The existing, consent-gated bootstrap owns permission to contact Trustpilot.
      if (window.Trustpilot?.loadFromElement) {
        if (!initialized) {
          container.replaceChildren(dialog.querySelector('template').content.cloneNode(true));
          window.Trustpilot.loadFromElement(container.firstElementChild, true);
          initialized = true;
        }
        if (container.querySelector('iframe')) {
          status.hidden = true;
          clearInterval(timer);
          return;
        }
      }
      if (++attempts >= 40) {
        status.hidden = true;
        retry.hidden = false;
        clearInterval(timer);
      }
    };
    timer = setInterval(tryLoad, 250);
    tryLoad();
  }
  function openReviews(target) {
    opener = target;
    dialog.showModal();
    document.body.classList.add('reviews-open');
    dialog.querySelector('[data-reviews-close]').focus();
    loadReviews();
  }
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const scoreButton = event.target.closest('[data-reviews-open]');
    const link = event.target.closest('a[href]');
    if (link?.hasAttribute('data-reviews-external')) return;
    let isProfile = false;
    if (link) {
      try {
        const url = new URL(link.href);
        isProfile = /(^|\.)trustpilot\.com$/.test(url.hostname) && url.pathname.replace(/\/$/, '') === '/review/senifone.nl';
      } catch (_) { /* Leave unrelated links alone. */ }
    }
    if (scoreButton || isProfile) {
      event.preventDefault();
      openReviews(scoreButton || link);
    }
  });
  dialog.querySelectorAll('[data-reviews-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.querySelector('[data-reviews-settings]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-reviews-load]').addEventListener('click', loadReviews);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    clearInterval(timer);
    document.body.classList.remove('reviews-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  // Compact TrustBoxes live in cross-origin iframes. Give them our own accessible
  // action so clicking the score opens the local dialog rather than an external tab.
  const scoreTemplates = new Set(['5406e65db0d04a09e042d5fc', '5419b637fa0340045cd0c936', '54197383fd9dceac42a68694', '5419b6ffb0d04a076446a9af', '5613c9cde69ddc09340c6beb']);
  function wireScores() {
    document.querySelectorAll('.trustpilot-widget').forEach(widget => {
      if (dialog.contains(widget)) return;
      if (['53aa8912dec7e10d38f59f36', '54ad5defc6454f065c28af8b'].includes(widget.dataset.templateId)) {
        if (!widget.nextElementSibling?.matches('[data-reviews-open]')) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'review-dialog__open-button';
          button.dataset.reviewsOpen = '';
          button.textContent = 'Lees alle reviews';
          widget.insertAdjacentElement('afterend', button);
        }
        return;
      }
      if (!scoreTemplates.has(widget.dataset.templateId)) return;
      widget.dataset.reviewsScore = '';
      widget.querySelectorAll('iframe, a').forEach(element => {
        element.setAttribute('tabindex', '-1');
        element.setAttribute('aria-hidden', 'true');
      });
      if (widget.querySelector('[data-reviews-open]')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'review-dialog__score-button';
      button.dataset.reviewsOpen = '';
      button.setAttribute('aria-label', 'Lees Trustpilot-reviews in een popup');
      widget.append(button);
    });
  }
  wireScores();
  new MutationObserver(wireScores).observe(document.body, { childList: true, subtree: true });
})();
